import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { PageInfo } from 'api/schemas'
import type { PriceHistoryState } from './types'

const initialState: PriceHistoryState = {
  pageInfo: {},
  items: [],
  product: null,
  chartData: [],
  sorting: {
    type: null,
    name: null,
    value: null,
  },
  query: '',
  selectedItems: [],
  filter: {
    type: null,
    value: null,
  },
  reviewPendings: 0,
  options: {},
  tableName: '',
  rangeValue: null,
}

const priceHistorySlice = createSlice({
  name: 'priceHistory',
  initialState,
  reducers: {
    setItems: (state, { payload }) => {
      state.items = payload
    },
    setChartData: (state, { payload }) => {
      state.chartData = payload
    },
    setProduct: (state, { payload }) => {
      state.product = payload
    },
    setPageInfo: (state, { payload }: { payload: Partial<PageInfo> }) => {
      state.pageInfo = payload
    },
    setSelectedItems: (state, { payload }) => {
      state.selectedItems = payload
    },
    setItemsRemoveSelection: (state, { payload }) => {
      state.items = payload.map(i => ({ ...i, selected: false }))
    },
    setSortingValue: (state, { payload }) => {
      state.sorting = payload
    },
    setQueryString: (state, { payload }) => {
      state.query = payload
    },
    setFilter: (state, { payload }) => {
      state.filter = payload
    },
    resetSorting: state => {
      state.sorting = initialState.sorting
    },
    setReviewsPendings: (state, { payload }) => {
      state.reviewPendings = payload
    },
    setTableName: (state, { payload }: PayloadAction<string>) => {
      state.tableName = payload
    },
    setRangeValue: (state, { payload }) => {
      state.rangeValue = payload
    },
    setOption: (
      state,
      { payload }: PayloadAction<{ option: string; value: unknown }>
    ) => {
      const { option, value } = payload
      state.options[option] = value
    },
    reset: state => {
      return { ...initialState, reviewPendings: state.reviewPendings }
    },
    updateRow: (state, { payload }: PayloadAction<any>) => {
      state.items = (state.items ?? []).map(row => {
        if (row.id !== payload.id) return row
        return { ...row, ...payload }
      })
    },
  },
})

export const { actions, reducer: priceHistory } = priceHistorySlice
export const {
  setItems,
  setChartData,
  setRangeValue,
  setProduct,
  setPageInfo,
  setSelectedItems,
  setSortingValue,
  setQueryString,
  updateRow,
  resetSorting,
  setReviewsPendings,
  setOption,
  setTableName,
  setFilter,
  reset,
} = actions
